import { clientInfoCache } from '../getClientInfo';
import { getParam, isDef } from '../utils';
import { bindPhone, login, ProductId } from '../common';
import { isUndef } from '../utils';
import skstockAppInfo from './skstockAppInfo';
import ymstockAppInfo from './ymstockAppInfo';
/**
 * 转化为int类型*
 * 如果不是无法转换为有效的int类型，则返回-1
 */
function parseToInt(num) {
    if (!num)
        return -1;
    if (typeof num === 'string') {
        num = parseInt(num, 10);
    }
    return isNaN(num) ? -1 : num;
}
var appInfo = {
    /**
     * 获取getClientInfo和url中的参数
     * @param name 参数名，不区分大小写
     * @returns
     */
    getParam: function (name) {
        var val;
        if (clientInfoCache) {
            val = clientInfoCache[name.toLowerCase()];
        }
        if (isUndef(val)) {
            var _val = getParam(name);
            val = isDef(_val) ? _val : '';
        }
        return val;
    },
    /**
     * 登录类型
     * 2 - 手机号登录
     * 0 - 匿名登录
     */
    get loginType() {
        return parseToInt(this.getParam('loginType'));
    },
    /**
     * app平台id
     */
    get productId() {
        var pd = parseToInt(this.getParam('appId') ||
            this.getParam('pd') ||
            this.getParam('pid') ||
            this.getParam('productId'));
        if (pd === -1) {
            pd = 4;
        }
        return pd;
    },
    /**
     * app平台id
     */
    get pd() {
        return this.productId;
    },
    /**
     * 渠道号
     */
    get vd() {
        return parseToInt(this.getParam('vd') || this.getParam('channelId'));
    },
    /**
     * 用户token
     */
    get token() {
        return this.getParam('token') || this.getParam('emoneyToken') || '';
    },
    /**
     * 是否为实名登录，
     * 支持的平台：智盈、有看投、基金APP
     */
    get isLogin() {
        var loginType = this.loginType;
        return !(loginType === -1 || loginType === 4);
    },
    /**
     * 是否为手机号实名登陆
     */
    get isPhone() {
        return factory('isPhone');
    },
    /**
     * 1. 是否已绑定手机号
     * 2. 包含手机号登录和第三方已绑定手机号
     * 3. 支持的平台：智盈、有看投、基金APP
     */
    get isBindPhone() {
        return this.loginType === 2 || this.getParam('hasBindPhone');
    },
    /**
     * 1. 检查是否登录手机号或已绑定手机号的第三方登录
     * 2. 如果未登录则自动触发登录
     * 3. 如果是第三方登录但未绑定手机号，则自动跳转绑定手机号
     * 4. 支持的平台：智盈、有看投、基金APP
     */
    get checkBindPhone() {
        var isBindPhone = true;
        if (!this.isLogin) {
            login();
            isBindPhone = false;
        }
        else if (!this.isPhone && !this.getParam('hasBindPhone')) {
            bindPhone();
            isBindPhone = false;
        }
        return isBindPhone;
    },
    /**
     * app版本号: '3.5.2',
     */
    get appVersion() {
        return this.getParam('mv') || this.getParam('appVersion') || '';
    },
    /**
     * app版本号数字: 985
     * 经典版可用此比对版本号
     */
    get appVersionNumber() {
        return parseToInt(this.appVersion.replace(/\./g, ''));
    },
    /**
     * 比较当前app版本号是否大于或等于目标版本号
     * @param version 目标版本号
     * @param options
     * @returns
     */
    compareVersion: function (version, options) {
        if (!version) {
            console.warn('版本比对异常：请传入要比对的版本号', version);
            return false;
        }
        var _options = {
            appVersion: appInfo.appVersion,
            isIncludeEqual: true
        };
        if (options) {
            Object.assign(_options, options);
        }
        var isSupport = false;
        var appVersion = _options.appVersion, isIncludeEqual = _options.isIncludeEqual;
        if (version === appVersion) {
            isSupport = isIncludeEqual;
        }
        else {
            var versionArr = version.split('.');
            var appVersionArr = appVersion.split('.');
            if (appVersionArr.length === versionArr.length) {
                for (var i = 0; i < appVersionArr.length; i++) {
                    if (appVersionArr[i] !== versionArr[i]) {
                        isSupport = +appVersionArr[i] > +versionArr[i];
                        break;
                    }
                }
            }
            else {
                isSupport = appVersionArr.length > versionArr.length;
            }
        }
        return isSupport;
    },
    /**
     * 状态栏高度
     */
    get statusBarHeight() {
        var statusBarHeight = 15;
        var clientStatusBarHeight = this.getParam('statusBarHeight');
        var screenHeight = Math.min(appInfo.getParam('screenWidth'), appInfo.getParam('screenHeight'));
        var pageHeight = Math.min(window.innerWidth, window.innerHeight);
        if (clientStatusBarHeight && screenHeight) {
            statusBarHeight = (pageHeight * clientStatusBarHeight) / screenHeight;
        }
        return statusBarHeight;
    },
    /**
     * 标题栏高度
     */
    get titleBarHeight() {
        var titleBarHeight = 40;
        var clientTitleBarHeight = this.getParam('titleBarHeight');
        var screenHeight = Math.min(appInfo.getParam('screenWidth'), appInfo.getParam('screenHeight'));
        var pageHeight = Math.min(window.innerWidth, window.innerHeight);
        if (clientTitleBarHeight && screenHeight) {
            titleBarHeight = (pageHeight * clientTitleBarHeight) / screenHeight;
        }
        return titleBarHeight;
    }
};
function factory(name) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (!clientInfoCache) {
        console.warn("[@em/ym]\u8C03\u7528\u51FD\u6570appInfo.".concat(name, "\u65B9\u6CD5\u4E4B\u524D, \u8BF7\u5148\u8C03\u7528getClientInfo"));
    }
    var result;
    switch (appInfo.productId) {
        case ProductId.Ymstock:
            result = ymstockAppInfo[name].apply(ymstockAppInfo, args);
            break;
        default:
            result = skstockAppInfo[name].apply(skstockAppInfo, args);
            break;
    }
    return result;
}
export { appInfo };
//# sourceMappingURL=AppInfo.js.map